// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cqyF","colMin":"styles_colMin__3tNR4"};